import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">INFLUENCING STRATEGIES</span>
                                            </div>
                                            <p>Consider the following ‘Influencing Strategies’ and think how
                                                they could be used to acheive greater influence.</p>

                                            <div className="desktop ipad-portrait-show">
                                                <table
                                                    className="ilead_v_sport tablesrink para-bottompad sept uiheading ilead_v_sport_new_task"
                                                    border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve green_curve1" align="left"
                                                            valign="center" width="100%" colSpan="3">Influencing
                                                            Strategies<a className="superscripttext boldlink"
                                                                         href="further_info.php?course=300"><sup>4</sup></a>
                                                        </th>


                                                    </tr>
                                                    <tr>
                                                        <td className="darkbrown " align="left" valign="center"
                                                            width="20%">
                                                            <div className=" "><p><span className="subtiltereg">Influence Strategy</span>
                                                            </p></div>
                                                        </td>
                                                        <td className="darkbrown" align="left" valign="center"
                                                            width="10%">
                                                            <div className=" "><p><span
                                                                className="subtiltereg">Definition</span></p>
                                                            </div>
                                                        </td>
                                                        <td className="darkbrown" align="left" valign="center"
                                                            width="10%">
                                                            <div className=" "><p><span className="subtiltereg">This works when...</span>
                                                            </p></div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Reason
                                                        </td>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>Utilising your logic, information and
                                                            deducing abilities to justify the request for an
                                                            action. Providing the evidence for a request allows
                                                            people to absorb the facts of your viewpoint into
                                                            their own. </p></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%">
                                                            <ul className="greenbullet-list">

                                                                <li>You have a high level of experience in the
                                                                    matter.
                                                                </li>
                                                                <li>The decision is very fact based.</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Assertion
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>By using direct and forceful requests
                                                            for an action to be taken, your confidence and
                                                            motivation in the desired course of action is shown.
                                                            See the iLEAD™ tool ‘How to be assertive’.</p></td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <ul className="greenbullet-list">
                                                                <li>You are experienced at influencing others.
                                                                </li>
                                                                <li>It is a strategic decision, where there is
                                                                    room for debate.
                                                                </li>

                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Exchange
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>This approach involves an exchange of
                                                            benefits, cooperation and compromise to reach a
                                                            goal. This makes the request seem mutually
                                                            beneficial, encouraging the participation of
                                                            others.</p></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%">
                                                            <ul className="greenbullet-list">

                                                                <li>The views of others need to be
                                                                    accommodated.
                                                                </li>
                                                                <li>You need to maintain a network of
                                                                    relationships to carry out the action.
                                                                </li>

                                                            </ul>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Courting Favour
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>This involves being friendly and/or
                                                            positive to the person you wish to influence. Those
                                                            who consider you a friend/friendly are far more
                                                            likely to assist you. See the iLEAD™ tool ‘How to
                                                            develop rapport’.</p></td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <ul className="greenbullet-list">

                                                                <li>You need to build a lasting influence.</li>
                                                                <li>There are personal factors involved in
                                                                    potential success.
                                                                </li>


                                                            </ul>
                                                        </td>

                                                    </tr>

                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Coercion
                                                        </td>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>This strategy influences using the
                                                            threat or application of scolding or punitive
                                                            actions. This works by discouraging people from not
                                                            following your plans and activities.</p></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%">
                                                            <ul className="greenbullet-list">

                                                                <li>You are not concerned about the feelings of
                                                                    others.
                                                                </li>
                                                                <li>You have a high level of authority.</li>


                                                            </ul>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Partnership
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>This involves garnering support from
                                                            several levels of an organisation in order to get a
                                                            multi-level consensus. This is likely to increase a
                                                            feeling of unity and participation in an action.</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <ul className="greenbullet-list">

                                                                <li>Wide participation in a project is needed.
                                                                </li>
                                                                <li>You have a wide network available to
                                                                    utilise.
                                                                </li>


                                                            </ul>
                                                        </td>

                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve green_curve1" align="left"
                                                            valign="center" width="100%" colSpan="3">Influencing
                                                            Strategies<a className="superscripttext boldlink"
                                                                         href="further_info.php?course=300"><sup>4</sup></a>
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th className="darkbrown" width="50%">Influence
                                                            Strategy
                                                        </th>
                                                        <td className="darkbrown-light">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Reason </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Definition</td>
                                                        <td valign="top" className="darkgreen">
                                                            <p>Utilising your logic, information and deducing
                                                                abilities to justify the request for an action.
                                                                Providing the evidence for a request allows
                                                                people to absorb the facts of your viewpoint
                                                                into their own. </p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">This
                                                            works when...
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <ul className="greenbullet-list">

                                                                <li>You have a high level of experience in the
                                                                    matter.
                                                                </li>
                                                                <li>The decision is very fact based.</li>
                                                            </ul>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Influence
                                                            Strategy
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Assertion </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Definition</td>
                                                        <td valign="top">
                                                            <p>By using direct and forceful requests for an
                                                                action to be taken, your confidence and
                                                                motivation in the desired course of action is
                                                                shown. See the iLEAD™ tool ‘How to be
                                                                assertive’.</p></td>


                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">This
                                                            works when...
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">

                                                                <li>You are experienced at influencing others.
                                                                </li>
                                                                <li>It is a strategic decision, where there is
                                                                    room for debate.
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Influence
                                                            Strategy
                                                        </th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Exchange </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Definition</td>
                                                        <td valign="top" className="darkgreen">
                                                            <p>This approach involves an exchange of benefits,
                                                                cooperation and compromise to reach a goal. This
                                                                makes the request seem mutually beneficial,
                                                                encouraging the participation of others.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">This
                                                            works when...
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <ul className="greenbullet-list">

                                                                <li>The views of others need to be
                                                                    accommodated.
                                                                </li>
                                                                <li>You need to maintain a network of
                                                                    relationships to carry out the action.
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Influence
                                                            Strategy
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Courting Favour </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Definition</td>
                                                        <td valign="top">
                                                            <p>This involves being friendly and/or positive to
                                                                the person you wish to influence. Those who
                                                                consider you a friend/friendly are far more
                                                                likely to assist you. See the iLEAD™ tool ‘How
                                                                to develop rapport’.</p></td>


                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">This
                                                            works when...
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">

                                                                <li>You need to build a lasting influence.</li>
                                                                <li>There are personal factors involved in
                                                                    potential success.
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Influence
                                                            Strategy
                                                        </th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Coercion </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Definition</td>
                                                        <td valign="top" className="darkgreen">
                                                            <p>This strategy influences using the threat or
                                                                application of scolding or punitive actions.
                                                                This works by discouraging people from not
                                                                following your plans and activities.</p></td>


                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">This
                                                            works when...
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <ul className="greenbullet-list">

                                                                <li>You are not concerned about the feelings of
                                                                    others.
                                                                </li>
                                                                <li>You have a high level of authority.</li>
                                                            </ul>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Influence
                                                            Strategy
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Partnership</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Definition</td>
                                                        <td valign="top">
                                                            <p>This involves garnering support from several
                                                                levels of an organisation in order to get a
                                                                multi-level consensus. This is likely to
                                                                increase a feeling of unity and participation in
                                                                an action.</p></td>


                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">This
                                                            works when...
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">

                                                                <li>Wide participation in a project is needed.
                                                                </li>
                                                                <li>You have a wide network available to
                                                                    utilise.
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>


                                            <p>Knowing how, when and where to use each of these strategies is
                                                key to successful influencing.
                                                Look for appropriate opportunities where you can practise using
                                                the ones you least favour, to
                                                develop a range of skills you can use in different
                                                situations.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}